
import React, { Component } from 'react';

export default class NoDiscountText extends Component {
    getCategory() {
        return this.props.order.getCategory()
    }
    isEligibleForDiscount() {
        const a = this.props.order.allow_discount
        return a
    }
    getContent = () => {
        return 
    }
    render() {
        return (
            !this.isEligibleForDiscount() ?
            <span>{lang.not_eligible_for_discount}</span> :
            null
        )
    }
}
